import React, { useContext, useMemo } from "react";
import { Intro } from "components/commons";
import { DownloadProgressModal } from "components/modals";
import locale from "localization";
import DiscountReportFilter from "./discount-report-filter";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { getTransactionItemsDiscountByStation } from "apis/transaction-discount";
import { initialFilterState } from "./discount-report-filter.state";
import { mapFilterToRequest, mapDataToList } from "./discount-report.mapper";
import { discountReportColumns } from "./discount-report-column";
import styles from "./discount-report.module.scss";
import { generateReport } from "apis/generate-report.api";
import useExport from "hooks/useExport";
import { useRouter } from "hooks";
import { UserContext } from "contexts";
import { Portal } from "enums";

const DiscountReportModule = () => {
  const { query } = useRouter();
  const { user } = useContext(UserContext);

  const stationCodes = useMemo(() => {
    const codes = user?.userAccesses
      ?.filter((access) => access.portal === Portal.HOS && access.station?.stationCode)
      .map(({ station }) => station.stationCode);
    return codes?.length > 0 ? codes.join(",") : undefined;
  }, [user?.userAccesses]);

  const { filter, search, table } = useDataTable({
    api: {
      api: getTransactionItemsDiscountByStation,
      params: {
        page: 1,
        perPage: 10,
        stationCodes,
      },
      mapper: (param) => {
        return param;
      },
    },
    searchKey: query?.promoName,
    filter: {
      initialState: {
        ...initialFilterState(),
        shiftId: query?.shiftId,
      },
      mapper: mapFilterToRequest,
    },
    table: {
      key: "transactionItems",
      mapper: (transactionItems) => mapDataToList({ transactionItems }),
      columns: discountReportColumns,
    },
  });

  const exports = useExport({
    api: generateReport,
    reportType: "transaction-item-discount",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      searchKey: search?.searchKey,
      portal: Portal.HOS.toLocaleLowerCase(),
    },
  });

  return (
    <>
      <Intro title={locale.discountReport} />
      <DiscountReportFilter {...filter} {...search} {...exports} />
      <DownloadProgressModal {...exports.downloadProgressModal} />
      <div className={styles.table}>
        <DataTableV2 {...table} />
      </div>
    </>
  );
};

export default DiscountReportModule;
